import { render, staticRenderFns } from "./IconTap.vue?vue&type=template&id=f11c8678&scoped=true&"
import script from "../../models/analysis/icon-tap.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/icon-tap.ts?vue&type=script&lang=ts&"
import style0 from "./IconTap.vue?vue&type=style&index=0&id=f11c8678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11c8678",
  null
  
)

export default component.exports